export default __webpack_public_path__ + "static/media/edit_report_name.ad9f972d.svg";